import * as service from './services'
import to from 'await-to-js'

export const state = {
  corpoClinico: null
}

export const getters = {
  corpoClinico: state => state.corpoClinico
}

export const mutations = {
  setCorpoClinico (state, payload) {
    state.corpoClinico = payload
  }
}

export const actions = {
  setCorpoClinico ({ commit }, payload) {
    commit('setCorpoClinico', payload)
  },
  async getCorpoClinico ({getters}) {
    if (!getters.rede) {
      return []
    }
    const [error, response = {data: []}] = await to(service.listProfissionais(getters.rede._id))

    if (error) {
      return Promise.reject(error.response.data)
    }

    return response.data
  },

  async saveCorpoClinico ({getters, dispatch}, payload) {
    dispatch('setLoading', true)
    payload.rede = getters.rede

    let result = !payload._id ? service.saveCorpoClinico(payload) : service.update(payload._id, payload)
    const [error, response = {data: []}] = await to(result)
    if (error) {
      dispatch('setLoading', false)
      dispatch('showErrorMsg', error)
      return Promise.reject(error)
    }
    dispatch('setLoading', false)
    dispatch('setCorpoClinico')
    return response.data
  },

  async removeCorpoClinico ({getters}, corpoClinico) {
    let payload = corpoClinico
    payload.status = 'INATIVO'
    payload.rede = getters.rede
    const [error, response = {data: []}] = await to(service.update(corpoClinico._id, payload))
    if (error) {
      return Promise.reject(error.response.data)
    }
    return response.data
  },

  async ativarCorpoClinico ({getters}, corpoClinico) {
    let payload = corpoClinico
    payload.status = 'ATIVO'
    payload.rede = getters.rede
    const [error, response = {data: []}] = await to(service.update(corpoClinico._id, payload))
    if (error) {
      return Promise.reject(error.response.data)
    }
    return response.data
  },

  async loadCorpoClinico ({getters, dispatch}, idCorpoClinico) {
    const [error, response = {data: []}] = await to(service.get(idCorpoClinico))
    if (error) {
      return Promise.reject(error.response.data)
    }
    let corpoClinico = response.data
    dispatch('setCorpoClinico', corpoClinico)
    return corpoClinico
  },

  async listAgendaPorProfissional ({getters}, idCorpoClinico) {
    const [error, response = {data: []}] = await to(service.getAgendaPorProfissional(idCorpoClinico))
    if (error) {
      return Promise.reject(error.response.data)
    }
    return response.data
  },

  async saveAgenda ({getters}, agenda) {
    const [error, response = {data: []}] = await to(service.saveAgenda(agenda))
    if (error) {
      return Promise.reject(error.response.data)
    }
    return response.data
  },

  async removeAgenda ({getters}, idAgenda) {
    const [error, response = {data: []}] = await to(service.removeAgenda(idAgenda))
    if (error) {
      return Promise.reject(error.response.data)
    }
    return response.data
  },

  async buscaProfissionais ({getters}, search) {
    const [error, response = {data: []}] = await to(service.findProfissionalByRede(getters.rede._id, search))
    if (error) {
      return Promise.reject(error.response.data)
    }
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/corpoClinico/index.js